export enum HistoryStatus {
  Ueberfaellig = 1,
  Offen = 2,
  In_Arbeit = 3,
  Durchgefuehrt = 4,
  Abgeschlossen = 5,
  Nicht_Angetroffen = 6,
  Neuer_Termin = 7,
  Custom = 8,
  Im_Aufbau = 9,
  None = 10,
  Akzeptiert = 11,
  Storniert = 12,
  Gebucht = 13,
  Abgegeben = 14,
}
